let _fbScriptLoaded = false;

const _ensureFbLoaded = () => {
    if (_fbScriptLoaded) return;
    _fbScriptLoaded = true;
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
    document,'script','https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
};

export const initSitePixel = () => {
    const pixelId = process.env.REACT_APP_MT_PIXEL_ID;
    if (!pixelId) return;
    _ensureFbLoaded();
    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');
};

export const initMetaPixel = (pixelId) => {
    if (!pixelId) return;
    _ensureFbLoaded();
    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');
};

export const trackPageView = () => {
    if (!window.fbq) return;
    window.fbq('track', 'PageView');
};

export const trackMetaEvent = (eventName, params, options) => {
    if (!window.fbq) return;
    if (options) {
        window.fbq('track', eventName, params || {}, options);
    } else {
        window.fbq('track', eventName, params || {});
    }
};
